import { useRecordContext } from 'react-admin'
export const ResultContactName = () => {
	const record = useRecordContext()
	return <span>{record && record.Contact && record.Contact.FullName ? `${record.Contact.FullName}` : ''}</span>
}
export default ResultContactName